import { ZoneId as ZoneId } from '@js-joda/core';
import { to2cs3ny02qtbcb as to } from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { RegionTimeZoneqfwrnej6ijxi as RegionTimeZone } from './RegionTimeZone.mjs';
import { IllegalTimeZoneException2q01rvpc2etsw as IllegalTimeZoneException } from '../Exceptions.mjs';
import {
  throwOnFailure24snjmtlqgzo8 as throwOnFailure,
  _Result___get_value__impl__bjfvqg9vwgdwmhxc4m as _Result___get_value__impl__bjfvqg,
  Companion_instancejy2056q2ma5w as Companion_instance,
  _Result___init__impl__xyqfz832zdzqrocazzs as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { setOf1u3mizs95ngxo as setOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  TimeZone3oibfp0mqo4lg as TimeZone,
  Companion_getInstance13ujfby7pfhe7 as Companion_getInstance,
  toInstant2ixtmlbww6j32 as toInstant,
  toInstant1fmt1re8uidf7 as toInstant_0,
} from '../TimeZone.mjs';
import { Companion_getInstance3qlladteis94 as Companion_getInstance_0 } from '../LocalTime.mjs';
import { atTime11qsxhu9qevxe as atTime } from '../LocalDate.mjs';
import {
  toNumber2e2hj9zugjwi2 as toNumber,
  fromInt2ii0rejb1w62w as fromInt,
  add2suhfggl4zvkk as add,
  numberToLong2pakxeg38estk as numberToLong,
  multiply2k9eolhnz1bjv as multiply,
  convertToInty04h231mmjoh as convertToInt,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { numberToInt1ygmcfwhs2fkq as numberToInt } from '../../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { UtcOffset2q1jzx5thduw7 as UtcOffset } from '../UtcOffset.mjs';
import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1n9qg6fb0b5i8 as toString,
  _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx,
  Char__minus_impl_a2frrhw2puetaduxyd as Char__minus_impl_a2frrh,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { charArrayOf27f4r3dozbrk1 as charArrayOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import {
  split3d3yeauc4rm2n as split,
  startsWith1bgirhbedtv2y as startsWith,
  get_lastIndexld83bqhfgcdd as get_lastIndex,
} from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber } from '../../../../kotlin-kotlin-stdlib/kotlin/js/rangeTo.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  charCodeAt1yspne1d8erbm as charCodeAt,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  getOrNull1go7ef9ldk0df as getOrNull,
  take3onnpy6q7ctcz as take,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { readTzdb1lgmqixljcgmm as readTzdb } from './PlatformSpecifics.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { TimeZoneRulesCommon3vpcb22l6ddoq as TimeZoneRulesCommon } from './TimeZoneRules.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_tzdb() {
  _init_properties_Platform_kt__37ezn1();
  return tzdb;
}
var tzdb;
function currentSystemDefaultZone() {
  _init_properties_Platform_kt__37ezn1();
  var id = ZoneId.systemDefault().id();
  return id === 'SYSTEM' ? to(id, SystemTimeZone_getInstance()) : to(id, null);
}
function timeZoneById(zoneId) {
  _init_properties_Platform_kt__37ezn1();
  var tmp;
  if (zoneId === 'SYSTEM') {
    var _destruct__k2r9zo = currentSystemDefaultZone();
    var name = _destruct__k2r9zo.component1_7eebsc_k$();
    var zone = _destruct__k2r9zo.component2_7eebsb_k$();
    if (zone == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      return zone;
    }
    tmp = name;
  } else {
    tmp = zoneId;
  }
  var id = tmp;
  var tmp1_safe_receiver = rulesForId(id);
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    return RegionTimeZone().new_kotlinx_datetime_internal_RegionTimeZone_3oghim_k$(tmp1_safe_receiver, id);
  }
  throw IllegalTimeZoneException().new_kotlinx_datetime_IllegalTimeZoneException_ascxr7_k$('js-joda timezone database is not available');
}
function getAvailableZoneIds() {
  _init_properties_Platform_kt__37ezn1();
  // Inline function 'kotlin.getOrThrow' call
  var this_0 = get_tzdb();
  throwOnFailure(this_0);
  var tmp0_safe_receiver = _Result___get_value__impl__bjfvqg(this_0);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.availableTimeZoneIds_p62ei_k$();
  return tmp1_elvis_lhs == null ? setOf('UTC') : tmp1_elvis_lhs;
}
var SystemTimeZoneClass;
function SystemTimeZone() {
  if (SystemTimeZoneClass === VOID) {
    class $ extends TimeZone() {
      constructor() {
        return new.target.new_kotlinx_datetime_internal_SystemTimeZone_dy7lrh_k$();
      }
      static new_kotlinx_datetime_internal_SystemTimeZone_dy7lrh_k$() {
        SystemTimeZone_instance = null;
        var $this = this.new_kotlinx_datetime_TimeZone_unj4p_k$();
        SystemTimeZone_instance = $this;
        return $this;
      }
      get_id_kntnx8_k$() {
        return 'SYSTEM';
      }
      atStartOfDay_893z35_k$(date) {
        return this.localDateTimeToInstant$default_ot8xqs_k$(atTime(date, Companion_getInstance_0().MIN_1));
      }
      offsetAtImpl_umwonf_k$(instant) {
        return UtcOffset(VOID, -numberToInt((new Date(toNumber(instant.toEpochMilliseconds_82cfls_k$()))).getTimezoneOffset()) | 0);
      }
      localDateTimeToInstant_1g6wu_k$(dateTime, preferred) {
        var epochMilli = toInstant(dateTime, Companion_getInstance().UTC_1).toEpochMilliseconds_82cfls_k$();
        var offsetInMinutesBeforePossibleTransition = numberToInt((new Date(toNumber(epochMilli))).getTimezoneOffset());
        // Inline function 'kotlin.Long.plus' call
        var other = imul(imul(offsetInMinutesBeforePossibleTransition, 60), 1000);
        var epochMilliSystemZone = add(epochMilli, fromInt(other));
        var offsetInMinutesAfterPossibleTransition = numberToInt((new Date(toNumber(epochMilliSystemZone))).getTimezoneOffset());
        var offset = UtcOffset(VOID, -offsetInMinutesAfterPossibleTransition | 0);
        return toInstant_0(dateTime, offset);
      }
      equals(other) {
        return other === this;
      }
      hashCode() {
        return getStringHashCode(this.get_id_kntnx8_k$());
      }
    }
    initMetadataForObject($, 'SystemTimeZone');
    SystemTimeZoneClass = $;
  }
  return SystemTimeZoneClass;
}
var SystemTimeZone_instance;
function SystemTimeZone_getInstance() {
  if (SystemTimeZone_instance === VOID)
    SystemTimeZone().new_kotlinx_datetime_internal_SystemTimeZone_dy7lrh_k$();
  return SystemTimeZone_instance;
}
function rulesForId(zoneId) {
  _init_properties_Platform_kt__37ezn1();
  // Inline function 'kotlin.getOrThrow' call
  var this_0 = get_tzdb();
  throwOnFailure(this_0);
  var tmp0_safe_receiver = _Result___get_value__impl__bjfvqg(this_0);
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.rulesForId_l3kmur_k$(zoneId);
}
function tzdb$charCodeToInt(char) {
  var tmp;
  if (_Char___init__impl__6a9atx(48) <= char ? char <= _Char___init__impl__6a9atx(57) : false) {
    tmp = Char__minus_impl_a2frrh(char, _Char___init__impl__6a9atx(48));
  } else if (_Char___init__impl__6a9atx(97) <= char ? char <= _Char___init__impl__6a9atx(122) : false) {
    tmp = Char__minus_impl_a2frrh(char, _Char___init__impl__6a9atx(97)) + 10 | 0;
  } else if (_Char___init__impl__6a9atx(65) <= char ? char <= _Char___init__impl__6a9atx(88) : false) {
    tmp = Char__minus_impl_a2frrh(char, _Char___init__impl__6a9atx(65)) + 36 | 0;
  } else {
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('Invalid character: ' + toString(char));
  }
  return tmp;
}
function tzdb$base60MinutesInSeconds(string) {
  var parts = split(string, charArrayOf([_Char___init__impl__6a9atx(46)]));
  var sign;
  var minuteNumberStart;
  if (startsWith(string, _Char___init__impl__6a9atx(45))) {
    minuteNumberStart = 1;
    sign = -1;
  } else {
    minuteNumberStart = 0;
    sign = 1;
  }
  var whole = parts.get_c1px32_k$(0);
  // Inline function 'kotlin.collections.map' call
  var this_0 = numberRangeToNumber(minuteNumberStart, get_lastIndex(whole));
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.first_1;
  var last = this_0.last_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = item;
      var tmp$ret$2 = tzdb$charCodeToInt(charCodeAt(whole, it));
      destination.add_utx5q5_k$(tmp$ret$2);
    }
     while (!(item === last));
  // Inline function 'kotlin.collections.fold' call
  var accumulator = 0n;
  var _iterator__ex2g4s = destination.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var acc = accumulator;
    // Inline function 'kotlin.Long.plus' call
    var this_1 = multiply(numberToLong(60), acc);
    accumulator = add(this_1, fromInt(element));
  }
  var wholeMinutes = accumulator;
  var tmp0_safe_receiver = getOrNull(parts, 1);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp_0;
    switch (tmp0_safe_receiver.length) {
      case 1:
        tmp_0 = tzdb$charCodeToInt(charCodeAt(tmp0_safe_receiver, 0));
        break;
      case 0:
        tmp_0 = 0;
        break;
      default:
        var tmp_1 = tzdb$charCodeToInt(charCodeAt(tmp0_safe_receiver, 0));
        // Inline function 'kotlin.let' call

        tmp_0 = tmp_1 + (tzdb$charCodeToInt(charCodeAt(tmp0_safe_receiver, 1)) >= 30 ? 1 : 0) | 0;
        break;
    }
    tmp = tmp_0;
  }
  var tmp1_elvis_lhs = tmp;
  var seconds = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  // Inline function 'kotlin.Long.times' call
  // Inline function 'kotlin.Long.plus' call
  var this_2 = multiply(wholeMinutes, fromInt(60));
  var tmp0 = add(this_2, fromInt(seconds));
  // Inline function 'kotlin.Long.times' call
  var other = sign;
  return multiply(tmp0, fromInt(other));
}
var tzdb$1Class;
function tzdb$1() {
  if (tzdb$1Class === VOID) {
    class $ {
      constructor($zones) {
        this.$zones_1 = $zones;
      }
      rulesForId_l3kmur_k$(id) {
        var tmp0_elvis_lhs = this.$zones_1.get_wei43m_k$(id);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw IllegalTimeZoneException().new_kotlinx_datetime_IllegalTimeZoneException_ascxr7_k$('Unknown time zone: ' + id);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      availableTimeZoneIds_p62ei_k$() {
        return this.$zones_1.get_keys_wop4xp_k$();
      }
    }
    initMetadataForClass($);
    tzdb$1Class = $;
  }
  return tzdb$1Class;
}
var properties_initialized_Platform_kt_qdcgvf;
function _init_properties_Platform_kt__37ezn1() {
  if (!properties_initialized_Platform_kt_qdcgvf) {
    properties_initialized_Platform_kt_qdcgvf = true;
    // Inline function 'kotlin.runCatching' call
    var tmp;
    try {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.mutableMapOf' call
        var zones = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
        var tmp0_elvis_lhs = readTzdb();
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          tmp$ret$1 = null;
          break $l$block;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var _destruct__k2r9zo = tmp_0;
        var zonesPacked = _destruct__k2r9zo.component1_7eebsc_k$();
        var linksPacked = _destruct__k2r9zo.component2_7eebsb_k$();
        var _iterator__ex2g4s = zonesPacked.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var zone = _iterator__ex2g4s.next_20eer_k$();
          var components = split(zone, charArrayOf([_Char___init__impl__6a9atx(124)]));
          // Inline function 'kotlin.collections.map' call
          var this_0 = split(components.get_c1px32_k$(2), charArrayOf([_Char___init__impl__6a9atx(32)]));
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
          var _iterator__ex2g4s_0 = this_0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
            var item = _iterator__ex2g4s_0.next_20eer_k$();
            var tmp$ret$5 = UtcOffset(null, null, -convertToInt(tzdb$base60MinutesInSeconds(item)) | 0);
            destination.add_utx5q5_k$(tmp$ret$5);
          }
          var offsets = destination;
          // Inline function 'kotlin.text.map' call
          var this_1 = components.get_c1px32_k$(3);
          // Inline function 'kotlin.text.mapTo' call
          var destination_0 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(charSequenceLength(this_1));
          var inductionVariable = 0;
          while (inductionVariable < charSequenceLength(this_1)) {
            var item_0 = charSequenceGet(this_1, inductionVariable);
            inductionVariable = inductionVariable + 1 | 0;
            var tmp$ret$8 = tzdb$charCodeToInt(item_0);
            destination_0.add_utx5q5_k$(tmp$ret$8);
          }
          var indices = destination_0;
          // Inline function 'kotlin.collections.map' call
          var this_2 = split(components.get_c1px32_k$(4), charArrayOf([_Char___init__impl__6a9atx(32)]));
          // Inline function 'kotlin.collections.mapTo' call
          var destination_1 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_2, 10));
          var _iterator__ex2g4s_1 = this_2.iterator_jk1svi_k$();
          while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
            var item_1 = _iterator__ex2g4s_1.next_20eer_k$();
            var tmp$ret$11 = tzdb$base60MinutesInSeconds(item_1);
            destination_1.add_utx5q5_k$(tmp$ret$11);
          }
          var lengthsOfPeriodsWithOffsets = destination_1;
          var tmp2 = components.get_c1px32_k$(0);
          var tmp$ret$12;
          $l$block_0: {
            // Inline function 'kotlin.collections.runningReduce' call
            var iterator = lengthsOfPeriodsWithOffsets.iterator_jk1svi_k$();
            if (!iterator.hasNext_bitz1p_k$()) {
              tmp$ret$12 = emptyList();
              break $l$block_0;
            }
            var accumulator = iterator.next_20eer_k$();
            // Inline function 'kotlin.apply' call
            var this_3 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(lengthsOfPeriodsWithOffsets, 10));
            this_3.add_utx5q5_k$(accumulator);
            var result = this_3;
            while (iterator.hasNext_bitz1p_k$()) {
              var tmp0 = accumulator;
              var p1 = iterator.next_20eer_k$();
              accumulator = add(tmp0, p1);
              result.add_utx5q5_k$(accumulator);
            }
            tmp$ret$12 = result;
          }
          // Inline function 'kotlin.let' call
          var it = tmp$ret$12;
          var tmp_1 = it.get_size_woubt6_k$() === (indices.get_size_woubt6_k$() - 1 | 0) ? it : take(it, indices.get_size_woubt6_k$() - 1 | 0);
          // Inline function 'kotlin.collections.map' call
          // Inline function 'kotlin.collections.mapTo' call
          var destination_2 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(indices, 10));
          var _iterator__ex2g4s_2 = indices.iterator_jk1svi_k$();
          while (_iterator__ex2g4s_2.hasNext_bitz1p_k$()) {
            var item_2 = _iterator__ex2g4s_2.next_20eer_k$();
            var tmp$ret$20 = offsets.get_c1px32_k$(item_2);
            destination_2.add_utx5q5_k$(tmp$ret$20);
          }
          // Inline function 'kotlin.collections.set' call
          var value = new (TimeZoneRulesCommon())(tmp_1, destination_2, null);
          zones.put_4fpzoq_k$(tmp2, value);
        }
        var _iterator__ex2g4s_3 = linksPacked.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_3.hasNext_bitz1p_k$()) {
          var link = _iterator__ex2g4s_3.next_20eer_k$();
          var components_0 = split(link, charArrayOf([_Char___init__impl__6a9atx(124)]));
          var tmp1_safe_receiver = zones.get_wei43m_k$(components_0.get_c1px32_k$(0));
          if (tmp1_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.collections.set' call
            var key = components_0.get_c1px32_k$(1);
            zones.put_4fpzoq_k$(key, tmp1_safe_receiver);
          }
        }
        tmp$ret$1 = new (tzdb$1())(zones);
      }
      // Inline function 'kotlin.Companion.success' call
      var value_0 = tmp$ret$1;
      tmp = _Result___init__impl__xyqfz8(value_0);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.Companion.failure' call
        tmp_2 = _Result___init__impl__xyqfz8(createFailure(e));
      } else {
        throw $p;
      }
      tmp = tmp_2;
    }
    tzdb = tmp;
  }
}
//region block: exports
export {
  currentSystemDefaultZone as currentSystemDefaultZone332b6s6k58wi,
  getAvailableZoneIds as getAvailableZoneIds230racjhvglas,
  timeZoneById as timeZoneByIdov6p8ve6cmmr,
};
//endregion

//# sourceMappingURL=Platform.mjs.map
